<div
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  [class.outline]="isDragOver()"
  [class.outline-2]="isDragOver()"
  [class.outline-dashed]="isDragOver()"
  [class.outline-primary-400]="isDragOver()"
  class="relative flex flex-col gap-1.5 rounded-xl outline-offset-4 transition-colors"
>
  @if (isDragOver()) {
    <div class="pointer-events-none absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 rounded-xl bg-primary-50/90">
      <i class="pi pi-cloud-upload text-3xl text-primary-400"></i>
      <p class="text-sm font-medium text-primary-500">{{ 'app.drop-files-here' | translate }}</p>
    </div>
  }

  <div class="flex items-center justify-between">
    <elcia-label [label]="label() | translate"/>
    <elcia-button (onClick)="openFilePicker()" [icon]="'plus'" [size]="'small'" [variant]="'text'"/>
  </div>

  @if (hint(); as hint) {
    <p class="text-xs text-surface-400 -mt-1 flex items-start gap-1.5">
      <i class="pi pi-info-circle mt-0.5" style="font-size: 0.7rem;"></i>
      <span>{{ hint | translate }}</span>
    </p>
  }

  @if (documents().length === 0 && pendingFiles().length === 0) {
    <div
      (click)="openFilePicker()"
      class="flex flex-col items-center justify-center gap-2 py-6 rounded-xl border-2 border-dashed border-surface-300 bg-surface-50 cursor-pointer transition-colors hover:border-primary-300 hover:bg-primary-50/50"
    >
      <i class="pi pi-cloud-upload text-2xl text-surface-300"></i>
      <p class="text-sm text-surface-500">{{ 'app.drop-files-here' | translate }}</p>
    </div>
  }

  @for (doc of documents(); track doc.id) {
    <elcia-document-item
      class="group flex items-center gap-4 px-4 py-3 rounded-xl border border-gray-200 bg-surface-0 hover:bg-primary-50 hover:border-surface-300 hover:shadow-sm transition-all"
      (onDelete)="onDelete.emit(doc)"
      (onDownload)="onDownload.emit(doc)"
      [document]="doc"
    />
  }

  @for (file of pendingFiles(); track $index) {
    <div class="flex items-center gap-4 group px-4 py-3 rounded-xl border border-amber-200 bg-amber-50/50 transition-all">
      <div class="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 bg-amber-50">
        <i [class]="getFileIcon(file.name)" class="text-xl opacity-70"></i>
      </div>

      <div class="flex-1 min-w-0">
        <p class="text-sm font-medium text-surface-700 truncate">{{ file.name }}</p>
        <p class="text-xs text-surface-400 mt-0.5 flex items-center gap-1.5">
          <span class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-amber-700 bg-amber-100 font-medium leading-none">
            <i class="pi pi-clock" style="font-size: 0.6rem;"></i>
            {{ 'app.pending-upload' | translate }}
          </span>
        </p>
      </div>

      <div class="flex items-center opacity-0 group-hover:opacity-100 transition-opacity">
        <elcia-button
          (onClick)="onRemovePendingFile.emit($index)"
          [icon]="'delete'"
          [severity]="'danger'"
          [size]="'small'"
          [variant]="'text'"
        />
      </div>
    </div>
  }

  <input #fileInput class="hidden" multiple type="file" (change)="handleFileChange($event)"/>
</div>
